module.exports = __webpack_public_path__ + "static/Gilroy-ExtraBold-278072130f50bc23a6e5baaea448e6c3.woff";